import { useMemo } from 'react'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { findVideoItemsOverlappingWithPlayhead } from 'store/features/projectData/thunks/utils'
import { useSelector } from 'react-redux'
import { useGetCurrentPlayheadTime } from 'hooks/timeline'
import { sortArraysByKey } from 'store/features/projectData/utils'
import { editorSelectors } from 'store/features/editor/selectors'
import { IMediaItem } from 'types/media'
// finds overlapping item
// prioritizes selected top line item
// or just top line item
export const useGetOverlappingVideoItem = () => {
  const mediaItems = useSelector(projectDataSelectors.mediaItems)

  const sortedMediaItems = useMemo(() => {
    return sortArraysByKey('startTime', mediaItems)
  }, [mediaItems])

  const playHeadTime = useGetCurrentPlayheadTime()
  const activeTimelineItemsIds = useSelector(
    editorSelectors.activeTimelineItemsIds
  )
  const overlappingVideoItems = useMemo(
    () => findVideoItemsOverlappingWithPlayhead(mediaItems, playHeadTime),
    [mediaItems, playHeadTime]
  )

  if (!overlappingVideoItems?.length)
    return { overlappingVideoItem: undefined, overlappingVideoIndex: -1 }

  if (overlappingVideoItems.length === 1)
    return {
      overlappingVideoItem: overlappingVideoItems[0],
      overlappingVideoIndex: sortedMediaItems.findIndex(
        item => item.id === overlappingVideoItems[0]?.id
      )
    }

  const firstSelectedItem = activeTimelineItemsIds.length
    ? overlappingVideoItems.reduce<IMediaItem | undefined>(
        (highest, current) => {
          if (!activeTimelineItemsIds.includes(current.id)) return highest
          if (!highest || current.zIndex >= highest.zIndex) return current
          return highest
        },
        undefined
      )
    : undefined

  const firstOverlappingItem = overlappingVideoItems.reduce(
    (highest, current) => {
      return current.zIndex >= highest.zIndex ? current : highest
    },
    overlappingVideoItems[0]
  )
  const overlappingVideoItem = firstSelectedItem || firstOverlappingItem
  const overlappingVideoIndex = sortedMediaItems.findIndex(
    item => item.id === overlappingVideoItem.id
  )
  return {
    overlappingVideoItem,
    overlappingVideoIndex
  }
}
